import { ValidButton } from "../../components/buttons/validButton";
import { saveModeHorsligne } from "../../functions/localStorage/saveLocalStorage";
import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext";
import { useConf } from "../../context/account/paramsAccount";
import { hookApi } from "../../hook/presta/affichePrestaHook";
import { useEffect, useRef, useState } from "react";
import { useError } from "../../context/erreur/erreurContext";
import { formatDate } from "../../functions/date/formatageDate";
import { saveHl } from "../../functions/HorsLigne/saveHL";
import { handleActivateOfflineMode, handleDesactivateOfflineMode } from "../../functions/HorsLigne/activeornotHl";
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL";
import { useNavigate } from 'react-router-dom';
import { deleteLocalStorage, deleteSelectedLocalStorage } from "../../functions/localStorage/deleteLocalStorage";
import ModalHl from "../../components/modalHl/modalhl";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Capacitor } from "@capacitor/core";

import { Storage } from "@capacitor/storage";
import AnimationLoading from "../../components/animationLoading/animationLoading";

//modalIsActive === 0 modal fermé
//modalIsActive === 1 modal save ou non 
//modalIsActive === 2 modal supprimer ou non 


export interface ListePresta {
    dev_id: number,
    pv_id: number,
    dp_id: number,
    v_cli_civ_nom: string,
    v_date_presta: string,
    v_designation: string,
    v_num_piece: string,
    v_adr_livraison: string,
    v_mode_vente: string,
    v_cnt_civ_nom: string,
    v_cnt_tel_mobile: string,
    isSent: any,
}
export function ModeHorsLigne() {
    const { showError } = useError();

    const { conf, setConf } = useConf();
    const { ifOffLineMode, toggleOfflineMode } = useOfflineMode();
    const [listePresta, setListePresta]: any = useState()
    const [listePrestaSave, setListePrestaSave]: any = useState()

    const [sendButton, setSendButton] = useState(false)
    const [selectedItems, setSelectedItems] = useState<ListePresta[]>([]);
    const [details, setDetails] = useState<any>(null);
    const [isSaved, setIsSaved] = useState(false)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [modalIsActiv, setModalIsActive] = useState(0)

    const isNativeApp = Capacitor.isNativePlatform();

    const enregistrerDataHl = (type: string) => {
        if (selectedItems.length > 0) {
            setIsLoading(true);
            if (type === "presta") {
                const requests = selectedItems.map((item: any) => {
                    const dataSend = {
                        e_pv_id: parseInt(item.pv_id),
                        e_dev_id: parseInt(item.dev_id),
                        e_dp_id: null
                    };
                    return saveHl('/posts/affiche-presta', dataSend, conf.token, conf, setConf, showError)
                        .then((response: any) => response);
                });

                Promise.all(requests)
                    .then((results: any[]) => {
                        const combinedResults = results.flat();

                        // Récupérer les prestations existantes hors-ligne
                        return Storage.get({ key: `prestaHl_${conf.user.user_code}` }).then((existingPrestations: any) => {
                            const existingPrestationsData = existingPrestations.value ? JSON.parse(existingPrestations.value) : [];

                            // Filtrer les nouvelles prestations pour éviter les doublons
                            const newPrestations = combinedResults.filter(newPrestation =>
                                !existingPrestationsData.some((existing: any) =>
                                    existing.entete.v_num_piece === newPrestation.entete.v_num_piece // Vérifie l'égalité
                                )
                            );

                            // Fusionner les nouvelles prestations avec les existantes
                            const updatedPrestations = [...existingPrestationsData, ...newPrestations];

                            // Enregistrer les prestations mises à jour
                            return saveModeHorsligne(updatedPrestations, 'prestaHl', conf).then(() => {
                                // Mettre à jour l'état
                                setDetails(updatedPrestations);
                                setIsSaved(true);
                                setSelectedItems([]);
                                activateModal(1);
                            });
                        });
                    })
                    .catch(error => {
                        console.error('Erreur lors de la récupération des détails :', error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }
    };

    const id = { id: conf?.user?.site?.sit_id }
    function recupListePresta() {
        hookApi('/posts/liste-presta', id, conf, setConf, setListePresta, showError)
    }
    useEffect(() => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    setDetails(data);
                    const entetes = data.map((item: any) => item.entete);
                    setListePrestaSave(entetes)
                } else {
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error))

    }, [conf, conf?.conf?.ifOffLineMode, modalIsActiv, selectedItems])

    // useEffect(() => {
    //     if (listePresta === undefined && ifOffLineMode === false) {
    //         handleDesactivateOfflineMode(setConf, conf, toggleOfflineMode)
    //     }
    // }, [listePresta])
    useEffect(() => {
        setListePresta(undefined)
    }, [ifOffLineMode])
    const toggleSelection = (item: ListePresta) => {
        navigate("/affiche-presta", { state: { pvId: item.pv_id, devId: item.dev_id, dpId: item.dp_id } });
    };

    const checkSelect = (item: ListePresta) => {
        setSelectedItems(prevSelected => {
            const isSelected = prevSelected.some(selectedItem => selectedItem.v_num_piece === item.v_num_piece);
            if (isSelected) {
                return prevSelected.filter(selectedItem => selectedItem.v_num_piece !== item.v_num_piece);
            } else {
                return [...prevSelected, item];
            }
        });
    }
    const activateModal = (number: number) => {
        setModalIsActive(number)
    }
    const takePrestaForSend = () => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    // Filtrer les éléments correspondant aux critères sélectionnés
                    const filteredItems = data.filter((item: any) => {
                        const matchesPvId = selectedItems.some((selected: ListePresta) =>
                            selected.pv_id === item.entete.pv_id
                        );
                        const matchesDevId = selectedItems.some((selected: ListePresta) =>
                            selected.dev_id === item.entete.dev_id
                        );

                        return matchesPvId && matchesDevId;
                    });
                    if (filteredItems.length > 0) {
                        filteredItems.forEach((filteredItem: any) => {
                            const { pv_id, dev_id } = filteredItem.entete;
                            const e_pv_id = pv_id === null ? null : isNaN(Number(pv_id)) ? null : Number(pv_id);
                            const e_dev_id = dev_id === null ? null : isNaN(Number(dev_id)) ? null : Number(dev_id);


                            const updatedDetails = filteredItem.result.map((phase: any) => ({
                                ...phase,
                                e_pv_id,
                                e_dev_id,
                            }));
                            // sendAllData(updatedDetails, conf, showError, showModal);
                        });
                    } else {
                    }
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    };
    return (
        <div className="container_cardHorsLigne">
            <div className="container_cardHl">
                <div>
                    <div className="container_title_text">
                        <span className="text">Retour de prestation</span>
                    </div>
                    <div className="container_presta">
                        {listePresta ?
                            listePresta.map((data: ListePresta) => (
                                <div
                                    key={data?.v_num_piece}
                                    className={`card_presta ${selectedItems.some(item => item?.v_num_piece === data?.v_num_piece) ? 'card_HLSelect' : ''}`}

                                >
                                    <div className="checkboxHL">
                                        <Checkbox
                                            label=""
                                            value={selectedItems.some(item => item?.v_num_piece === data?.v_num_piece) ? true : false}
                                            onChange={(e) => {
                                                e.nativeEvent.stopPropagation();
                                                checkSelect(data);
                                            }}
                                        />
                                    </div>
                                    <div className="cardbody">
                                        <div className={
                                            !data?.isSent
                                                ? "header_card_presta header_card_prestaHl"
                                                : "header_card_presta_hl header_card_prestaHl "
                                        } onClick={(e) => { checkSelect(data); }}>
                                            <div className="header_text_presta">
                                                <p>{data?.v_num_piece !== "" ? data?.v_num_piece : ""}</p>
                                                <p>{data?.v_date_presta !== "" ? formatDate(data?.v_date_presta) : ""}</p>
                                            </div>
                                            <p className="modevente_text">{data?.v_mode_vente}</p>
                                        </div>
                                        <div onClick={(e) => { checkSelect(data) }}>
                                            <div className="body_card_presta">
                                                <p>{data?.v_designation !== "" ? data?.v_designation : ""}</p>
                                            </div>
                                            <div className="footer_card_presta" >
                                                <p className="overflow">{data?.v_cli_civ_nom !== "" ? data?.v_cli_civ_nom : ""}</p>
                                                <p className="livraison_text overflow">{data?.v_adr_livraison !== "" ? data?.v_adr_livraison : ""}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : ""
                        }
                        {
                            conf.conf.ifOffLineMode === false ?
                                <div className="containerResearchSave">
                                    <ValidButton onClick={recupListePresta}>Rechercher</ValidButton>
                                    <ValidButton onClick={() => { enregistrerDataHl('presta'); }} >Enregistrer</ValidButton>
                                </div> : ''
                        }
                    </div>
                    <span className="container_title_text">Prestation Enregistré</span>
                    <div className="container_presta">
                        {listePrestaSave ?
                            listePrestaSave.map((data: ListePresta) => (
                                <div
                                    key={data?.v_num_piece}
                                    className={`card_presta ${selectedItems.some(item => item?.v_num_piece === data?.v_num_piece) ? 'card_HLSelect' : ''}`}

                                >
                                    <div className="checkboxHL">
                                        <Checkbox
                                            label=""
                                            value={selectedItems.some(item => item?.v_num_piece === data?.v_num_piece) ? true : false}
                                            onChange={(e) => {
                                                e.nativeEvent.stopPropagation();
                                                checkSelect(data);
                                            }}
                                        />
                                    </div>

                                    <div className="cardbody">
                                        <div className={
                                            !data?.isSent
                                                ? "header_card_presta header_card_prestaHl"
                                                : "header_card_presta_hl  header_card_prestaHl"
                                        } onClick={(e) => { checkSelect(data); }}>
                                            <div className="header_text_presta">
                                                <p>{data?.v_num_piece !== "" ? data?.v_num_piece : ""}</p>
                                                <p>{data?.v_date_presta !== "" ? formatDate(data?.v_date_presta) : ""}</p>
                                            </div>
                                            <p className="modevente_text">{data?.v_mode_vente}</p>
                                        </div>
                                        <div onClick={(e) => { toggleSelection(data) }}>
                                            <div className="body_card_presta">
                                                <p>{data?.v_designation !== "" ? data?.v_designation : ""}</p>
                                            </div>
                                            <div className="footer_card_presta" >
                                                <p className="overflow">{data?.v_cli_civ_nom !== "" ? data?.v_cli_civ_nom : ""}</p>
                                                <p className="livraison_text overflow">{data?.v_adr_livraison !== "" ? data?.v_adr_livraison : ""}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : ""
                        }

                        {
                            listePrestaSave ?
                                <div className="containerResearchSave">
                                    <ValidButton onClick={() => { activateModal(4); }} >Supprimer</ValidButton>
                                    {/* <ValidButton onClick={() => { activateModal(3) }} >Envoyer</ValidButton> */}
                                </div> : ''
                        }
                    </div>
                </div>
            </div>

            <div className="card indisponible">
                <span className="text">Retour matériel / consommations</span>
            </div>
            <div className="card indisponible">
                <span className="text">Besoins labo / cuisine</span>
            </div>
            {/* <div className="positionButton">
                <ValidButton onClick={} >Enregistrer</ValidButton>
            </div> */}
            <AnimationLoading
                isLoading={isLoading}
                text=""
            />

            <div className={`${isLoading ? 'chargementRegisterHl' : 'chargementRegisterHlNone'}`}>
                <div className="overlay"></div>
                <div className="spinner"></div>
            </div>
            {isNativeApp &&
                (isSaved === true && conf?.conf?.ifOffLineMode === false && modalIsActiv === 1) || (isSaved === true && conf?.conf?.ifOffLineMode === undefined && modalIsActiv === 1) ?
                <ModalHl
                    handleActivateOfflineMode={() => { handleActivateOfflineMode(setConf, conf, toggleOfflineMode); activateModal(0) }}
                    handleDesactivateOfflineMode={() => { handleDesactivateOfflineMode(setConf, conf, toggleOfflineMode); activateModal(0) }}
                    message="L'enregistrement s'est bien effectué, voulez-vous activer le mode hors ligne tout de suite ?"
                ></ModalHl>
                : ''
            }

            <div className="supressionLocalHl">
                <ValidButton onClick={() => { activateModal(2); setSendButton(true) }}>Supprimer les éléments enregistrés</ValidButton>
            </div>

            {
                modalIsActiv === 2 ?
                    <ModalHl
                        handleActivateOfflineMode={() => { deleteLocalStorage(`prestaHl_${conf.user.user_code}`, setListePrestaSave); handleDesactivateOfflineMode(setConf, conf, toggleOfflineMode); activateModal(0) }}
                        handleDesactivateOfflineMode={() => { activateModal(0) }}
                        message="Souhaitez-vous supprimer les éléments enregistrés ?"
                    ></ModalHl>
                    : ""
            }
            {
                modalIsActiv === 3 ?
                    <ModalHl
                        handleActivateOfflineMode={() => { takePrestaForSend(); activateModal(0) }}
                        handleDesactivateOfflineMode={() => { activateModal(0) }}
                        message="Souhaitez-vous envoyer les éléments séléctionnés ?"
                    ></ModalHl>
                    : ""
            }
            {
                modalIsActiv === 4 ?
                    <ModalHl
                        handleActivateOfflineMode={() => { deleteSelectedLocalStorage(`prestaHl_${conf.user.user_code}`, selectedItems, setSelectedItems); activateModal(0) }}
                        handleDesactivateOfflineMode={() => { activateModal(0) }}
                        message="Souhaitez-vous supprimer les éléments séléctionnés ?"
                    ></ModalHl>
                    : ""
            }
        </div>
    )
}